import React, { useState } from 'react';
import {
  Typography,
  IconButton,
  Button,
  FormControl,
  OutlinedInput,
  InputAdornment,
} from '@mui/material';
import { EventBus } from '@/shared/utils';
import { CancelRounded, SearchRounded } from '@mui/icons-material';
import { Catalog as CatalogDict } from '@/shared/i18n';
import { CatalogEvents, CatalogEventKeys } from '../../../events';
import { catalogEndpoints } from '../../../utils/endpoints';

type CatalogSearchProps = {
  dict: CatalogDict;
  eventBus: EventBus<CatalogEvents>;
};

const CatalogSearch = ({ dict, eventBus }: CatalogSearchProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const handleClear = () => {
    setSearchQuery('');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    eventBus.emit(CatalogEventKeys.navigate.do, {
      slug: catalogEndpoints.search(searchQuery),
    });
  };

  return (
    <div className="relative flex flex-col w-full gap-8 px-4 py-8 md:px-8 rounded-xl bg-paper">
      <Typography variant="h1" className="w-full text-center z-[2]" component="h1">
        Esplora il catalogo
      </Typography>
      <form onSubmit={handleSubmit} className="flex flex-col self-center max-w-[900px] w-full">
        <FormControl variant="outlined" className="w-full">
          <OutlinedInput
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-0 md:pl-4 pr-2"
            placeholder="Cerca un argomento, un insegnante, un percorso"
            startAdornment={
              <InputAdornment position="start" className="mr-0 hidden md:block">
                <SearchRounded className="text-text-secondary h-[18px]" />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                {searchQuery && (
                  <IconButton aria-label="clear value" onClick={handleClear}>
                    <CancelRounded className="text-text-secondary h-[16px]" />
                  </IconButton>
                )}
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  color="primary"
                  className="h-[36px] ml-2 px-2 md:px-8"
                  sx={{ minWidth: 'auto' }}
                  disabled={!searchQuery}
                >
                  <Typography variant="button-s" className="hidden md:block">
                    Cerca
                  </Typography>
                  <SearchRounded className="text-white h-[18px] block md:hidden" />
                </Button>
              </InputAdornment>
            }
            sx={{
              '.MuiOutlinedInput-input': {
                paddingLeft: { md: '6px' },
                paddingRight: '6px',
              },
            }}
          />
        </FormControl>
      </form>
    </div>
  );
};

export default CatalogSearch;
